import React, {useRef, useState} from 'react';
import AvatarEditor from "react-avatar-editor";
import 'react-image-crop/dist/ReactCrop.css';
import './imageCropper.css'
import {FormattedMessage} from "react-intl";
import CustomModalV2 from "../custom-modal-v2/custom-modal-v2";

function ImageCropper({image, onClose, open, onCrop}) {
    const [scale, setScale] = useState(1);
    const avatarEditorRef = useRef();

    const handleCropComplete = () => {
        avatarEditorRef.current.getImageScaledToCanvas().toBlob((blob) => {
            const file = new File([blob], "croppedImage.jpg", {type: "image/jpg"});

            setScale(1)
            onCrop(file);
            onClose();
        }, "image/png");
    };

    const handleMouseWheel = (event) => {
        if (event.target) {
            const deltaY = event.deltaY;

            if (deltaY > 0) {
                let newScale = Math.max(scale / 1.1, 1);
                setScale(newScale);
            } else if (deltaY < 0) {
                setScale(scale * 1.1);
            }
        }
    };

    return (
        <CustomModalV2 open={open} onClose={onClose} title={<FormattedMessage id="profile.crop-modal.title"/>}
                       primaryButton={{
                           text: <FormattedMessage id="profile.crop-modal.complete"/>,
                           onClick: handleCropComplete,
                           value: 'primary'
                       }}>
            <>
                {image && <div className="col-12 d-flex justify-content-center" onWheel={e => handleMouseWheel(e)}>
                    <AvatarEditor
                        style={{border: '2px solid rgba(0,0,0,.125)', borderRadius: "4px"}}
                        image={image}
                        width={250}
                        height={250}
                        border={50} // ajusta el tamaño del borde del recorte
                        color={[255, 255, 255, 0.8]} // color del fondo del recorte
                        scale={scale}
                        rotate={0}
                        ref={avatarEditorRef}
                    />
                </div>}
            </>
        </CustomModalV2>
    )
}

export default ImageCropper;
